import React from "react";

const SvgExport2 = props => (
  <svg viewBox="0 0 200 200" {...props}>
        <g id="Obecn�_ikony">
            <g id="Export2">
                <path d="M 101.3 43.5 C 101.9 43.5 102.3 43.6 102.8 43.8 C 103.3 44 103.7 44.3 104.1 44.6 L 122.1 63 C 123.6 64.5 123.5 66.9 122.1 68.3 C 120.6 69.8 118.2 69.8 116.8 68.3 L 105 56.4 L 105 109 C 105 111.1 103.3 112.8 101.2 112.8 C 99.1 112.8 97.4 111.1 97.4 109 L 97.4 56.3 L 85.6 68.1 C 84.1 69.6 81.7 69.6 80.3 68.1 C 79.6 67.4 79.2 66.4 79.2 65.4 C 79.2 64.4 79.6 63.5 80.3 62.7 L 98.6 44.7 C 98.6 44.7 98.6 44.7 98.6 44.6 C 99.3 43.9 100.3 43.5 101.3 43.5 Z M 61 82.8 L 86 82.8 C 88 82.8 89.6 84.4 89.6 86.4 C 89.6 88.4 88 90 86 90 L 62.4 90 L 62.4 132.7 L 140 132.7 L 140 90.1 L 116.1 90.1 C 114.1 90.1 112.5 88.5 112.5 86.5 C 112.5 84.5 114.1 82.9 116.1 82.9 L 141.4 82.9 C 144.6 82.9 147.3 85.3 147.3 88.5 L 147.3 134.5 C 147.3 137.7 144.5 140.1 141.4 140.1 L 61 140.1 C 57.8 140.1 55.1 137.7 55.1 134.5 L 55.1 88.5 C 55.1 85.2 57.9 82.8 61 82.8 Z" />
            </g>
        </g>
  </svg>
);

export default SvgExport2;

